import React, { Component } from 'react';
import i18next from "../../i18n";
import { hideModalDialog, showModalDialog } from '../ModalDialog';
export class EditFolderForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            title: '',
            showIsSimpleRequestInput: this.props.showIsSimpleRequestInput,
            showIsCertificateInput: this.props.showIsCertificateInput,
            isSimpleRequestFolder: false,
            isCertificateFolder: false,
            sending: !!props.oldName,
            folderType: this.props.folderType,
            submitted: false,
            titleExists: false,
            incorrectName: false,
            alreadyExists: false
        };
        this.changeInputValue = this.changeInputValue.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.onCancel = this.onCancel.bind(this);
    }
    componentDidMount() {
        this.fillForm();
    }
    changeInputValue(e) {
        const { name, value, type } = e.target;
        this.setState({ [name]: type === "checkbox" ? e.target.checked : value, incorrectName: false, alreadyExists: false });
    }
    async fillForm() {
        const { baseDir } = this.props;
        if (!!this.props.oldName) {
            let url = `home/getFolder?baseDir=${baseDir}&name=${this.props.oldName}`;
            const response = await fetch(url);
            const data = await response.json();
            if (!response.ok) {
                require('../ModalDialogsTemplates').unknownErrorMessageDialog();
            }
            else {
                this.setState({ name: data.folder.name, title: data.folder.title, isSimpleRequestFolder: data.isSimpleRequestFolder, isCertificateFolder: data.isCertificateFolder, sending: false });
            }
        }
    }
    handleSubmit(event) {
        event.preventDefault();
        const { sending, name, incorrectName, alreadyExists, isSimpleRequestFolder, isCertificateFolder } = this.state;
        this.setState({ submitted: true });
        if (!sending && !incorrectName && !alreadyExists && name && name.trim()) {
            this.setState({ sending: true });
            let oldName = this.props.oldName;
            this.submit({
                name: name.trim(),
                oldName,
                isSimpleRequestFolder,
                isCertificateFolder
            });
        }
    }
    async submit(data) {
        const { baseDir } = this.props;
        const currentObject = this;
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        };
        var url = !!data.oldName ? `/home/editFolder?baseDir=${baseDir}` : `/home/addFolder?baseDir=${baseDir}`;
        fetch(url, requestOptions)
            .then((response) => {
                if (response.status === 403) {
                    hideModalDialog("loadingDialog");
                    import('../ModalDialogsTemplates').then(templates => { templates.errorMessageDialog(i18next.t("12")) });
                    return;
                }
                return response.ok ? response.text().then(() => {
                    currentObject.setState({ sending: false });
                    function onClose() {
                        hideModalDialog("loadingDialog");
                        window.onbeforeunload = null;
                        window.location.replace(`${window.location.pathname.split('/').slice(0, 3).join('/')}/${data.name ? data.name : data.oldName}`);
                    }
                    showModalDialog("loadingDialog", i18next.t("done"), "", <div className="info-message">{data.oldName ? i18next.t("folderSuccessfullySaved") : i18next.t("folderSuccessfullyAdded")}</div>, "feedPopup", true, [{ title: i18next.t("ok"), clickHandler: () => onClose(), class: "btn-primary" }], onClose);
                }) : response.text().then((errorText) => {
                    if (["IncorrectName", "AlreadyExists"].indexOf(errorText) !== -1) {
                        this.setState({ [errorText[0].toLowerCase() + errorText.substring(1)]: true, sending: false });
                    }
                    else {
                        console.log(errorText);
                        require('../ModalDialogsTemplates').unknownErrorMessageDialog();
                    }
                });
            });
    }
    onCancel() {
        const { onCloseHandler } = this.props;
        if (!this.state.sending && onCloseHandler)
            onCloseHandler();
    }
    render() {
        const { name, sending, submitted, incorrectName, alreadyExists, showIsSimpleRequestInput, showIsCertificateInput, isSimpleRequestFolder, isCertificateFolder } = this.state;
        return (
            <>
                <div className="modal-body">
                    <form name="form" className="popupSimple user-invite-form">
                        <div className="row">
                            <div className={'form-group col-sm-12 col-xs-12' + (submitted && !name ? ' has-error' : '')}>
                                <label htmlFor={Object.keys({ name })[0]} className="required">{i18next.t("folderName")}</label>
                                <input className="form-control" name={Object.keys({ name })[0]} value={name} disabled={(sending ? 'disabled' : '')} onChange={this.changeInputValue} />
                                {submitted && (!name || !name.trim()) &&
                                    <div className="help-block">{i18next.t("requiredField")}</div>
                                }
                                {submitted && name && incorrectName &&
                                    <div className="help-block">{i18next.t("badFieldFormat")}</div>
                                }
                                {submitted && name && alreadyExists &&
                                    <div className="help-block">{i18next.t("folderAlreadyExists")}</div>
                                }
                            </div>
                            {showIsSimpleRequestInput && <div className="form-group col-sm-12 col-xs-12">
                                <div className="checkbox-form dialog-form-checkbox">
                                    <div>
                                        <input id="isSimpleRequestFolder" name="isSimpleRequestFolder" checked={isSimpleRequestFolder} className="form-control" onChange={this.changeInputValue} type="checkbox" disabled={(sending ? "disabled" : "")} />
                                        <label htmlFor="isSimpleRequestFolder">{i18next.t("isSimpleRequestFolderLabel")}</label>
                                    </div>
                                </div>
                            </div>}
                            {showIsCertificateInput && <div className="form-group col-sm-12 col-xs-12">
                                <div className="checkbox-form dialog-form-checkbox">
                                    <div>
                                        <input id="isCertificateFolder" name="isCertificateFolder" checked={isCertificateFolder} className="form-control" onChange={this.changeInputValue} type="checkbox" disabled={(sending ? "disabled" : "")} />
                                        <label htmlFor="isCertificateFolder">{i18next.t("isCertificateFolderLabel")}</label>
                                    </div>
                                </div>
                            </div>}
                            <div className='form-group'>
                            </div>
                        </div>
                    </form>
                </div>
                <div className="modal-footer">
                    <div className="form-group form-group__last">
                        <button className="btn btn-primary" onClick={this.handleSubmit}>{i18next.t("save")}</button>
                        <button type="button" className="btn btn-secondary" onClick={this.onCancel}>{i18next.t("cancel")}</button>
                        <div className="required-label">
                            <label className="required" /><span className="red">*</span> {i18next.t("requiredFields")}
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
